import { render, staticRenderFns } from "./PurchaseOrderAttachments.vue?vue&type=template&id=2a68a6ea"
import script from "./PurchaseOrderAttachments.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderAttachments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports